import { ScaleTime } from "d3"

export function getClampedStartAndEnd(startTime: number, endTime: number, fileScale: ScaleTime<any, any, any>): { start: number; end: number } {
	let newStartTime = startTime
	let newEndTime = endTime

	const [recordingStartDate, recordingEndDate] = fileScale.domain()
	const recordingStartTime = recordingStartDate.getTime()
	const recordingEndTime = recordingEndDate.getTime()
	const viewDuration = endTime - startTime

	if (newEndTime > recordingEndTime) {
		newEndTime = recordingEndTime
		newStartTime = newEndTime - viewDuration
	}

	if (newEndTime < recordingStartTime) {
		newEndTime = recordingStartTime
		newStartTime = newEndTime - viewDuration
	}

	return { start: newStartTime, end: newEndTime }
}
